import Head from 'next/head'
import { useRouter } from 'next/router'
import { useTranslation } from '@mc/i18n'
import {
  DEFAULT_THUMBNAIL,
  OG_IMAGE_HEIGHT,
  SITE_NAME,
  TWITTER_CARD,
  TWITTER_HANDLE,
} from 'libs/constants'
import { getUrlWithoutQueryParams } from 'libs/utils'

export const Meta = () => {
  const { t } = useTranslation('@mc/next')
  const { asPath } = useRouter()

  return (
    <Head>
      <title>{t('guestPass.meta.title')}</title>
      <meta content={t('guestPass.meta.description')} name='description' />
      <meta content={t('guestPass.meta.keywords')} name='keywords' />
      <meta
        content='-VH0v01sv1yndHZzRTVr0Sk6D2e_xiEDT5b6Z9Ca9Qo'
        name='google-site-verification'
      />
      <meta content={getUrlWithoutQueryParams(asPath)} property='og:url' />
      <meta content={SITE_NAME} property='og:site_name' />
      <meta content={t('guestPass.meta.title')} property='og:title' />
      <meta
        content={t('guestPass.meta.socialDescription')}
        property='og:description'
      />
      <meta content={DEFAULT_THUMBNAIL} property='og:image' />
      <meta content={OG_IMAGE_HEIGHT} property='og:image:height' />
      <meta content={TWITTER_CARD} name='twitter:card' />
      <meta content={TWITTER_HANDLE} name='twitter:site' />
      <meta content={t('guestPass.meta.title')} property='twitter:title' />
      <meta
        content={t('guestPass.meta.socialDescription')}
        name='twitter:description'
      />
      <meta content={DEFAULT_THUMBNAIL} name='twitter:image' />
      <meta name='robots' content='noindex' />
    </Head>
  )
}
